import React, { useState, useEffect } from 'react';

const CountdownTimer = ({
  minutes,
  text,
  onClickWhenCountDownFinish,
  tema,
}) => {
  const [seconds, setSeconds] = useState(null);

  const isEnabled = seconds === 0;
  useEffect(() => {
    setSeconds(minutes * 60);
    const intervalId = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 1) return prevSeconds - 1;

        clearInterval(intervalId);
        return 0;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [minutes]);

  const displayMinutes = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');

  const displaySeconds = (seconds % 60).toString().padStart(2, '0');

  const displayTime = seconds > 0 ? `${displayMinutes}:${displaySeconds}` : '';

  async function handleOnClickWhenCountDownFinish() {
    if (isEnabled) {
      await onClickWhenCountDownFinish();
    }
  }

  return (
    <a
      onClick={handleOnClickWhenCountDownFinish}
      style={{
        color: isEnabled ? tema.primaryColor : '#B1B3B3',
        cursor: isEnabled ? 'pointer' : '',
        fontWeight: 600,
      }}
    >
      {text} {displayTime}
    </a>
  );
};

export default CountdownTimer;
